actions:
  back: Terug naar home
errors:
  402:
    title: Pagina niet gevonden
    description: De pagina die je zoekt bestaat niet of is verplaatst.
  403:
    title: Geen toegang
    description: Je hebt geen toestemming om deze pagina te bekijken.
  404:
    title: Pagina niet gevonden
    description: De pagina die je zoekt bestaat niet of is verplaatst.
  500:
    title: Server fout
    description: Er is iets misgegaan aan onze kant. We werken eraan om het op te lossen.
